import React from 'react'

import { Divider, Button, makeStyles } from '@material-ui/core'

import useContract from 'hooks/useContract'
import styles from './styles'

const useStyles = makeStyles(styles)

const Footer = ({ nextButtonText = 'Continuar', nextButtonProps = {} }) => {
  const classes = useStyles()
  const { activeStep, backStep } = useContract()
  const isFirstStep = activeStep === 0

  const handleClickBackButton = () => backStep()

  return (
    <div>
      <Divider />

      <div className={classes.buttonGroup}>
        <Button
          variant="outlined"
          color="primary"
          disabled={isFirstStep}
          onClick={handleClickBackButton}
        >
          Voltar
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          {...nextButtonProps}
        >
          {nextButtonText}
        </Button>
      </div>
    </div>
  )
}

export default Footer
